import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { darkBlue, white } from '../../Constants/Colors';
import { getSystemParametersWithSelectedOption } from '../../Reducers/App/Selectors';
import Grid from '@material-ui/core/Grid';
import ComponentFieldRenderer from './ComponentFieldRenderer';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { ComponentInputType } from './types';
import { FieldType } from '../FormBuilder/types';
import Subtitle from '../Header/Subtitle';
import FormFieldRenderer from '../FormBuilder/FormFieldRenderer';
import OptionComment from '../Configurator/OptionComment';

export const useStyles = makeStyles((theme) => ({
  root: {
    background: darkBlue,
    flex: 1,
    color: white,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 2rem',
  },
  scrollableContainer: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  componentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundColor: darkBlue,
  },
  component: {
    minWidth: 'max(350px, 40%)',
    maxWidth: 'max(350px, 40%)',
    '&:nth-child(odd)': {
      marginRight: '10%',
    },
    flex: 1,
  },
  labelContainer: {
    padding: '16px 0',
    '& label': {
      display: 'block',
      margin: theme.spacing(1, 1, 1, 0),
      fontSize: '1.2em',
    },
  },
  subTitle: {
    marginBottom: '1.5rem',
  },
}));

const componentInputTypes: ComponentInputType = {
  material_certificates: FieldType.CHECKBOX,
  width: FieldType.SELECT,
  length: FieldType.SELECT,
  steel_belt_cooler: FieldType.SELECT,
  label_language: FieldType.SELECT,
  delivery_method: FieldType.SELECT,
  packaging: FieldType.SELECT,
  control: FieldType.SELECT,
  certificates: FieldType.SELECT,
  ex_zone_rotoform: FieldType.SELECT,
  ex_zone_sbc: FieldType.SELECT,
  heating_medium: FieldType.SELECT,
};

const comments = {
  identifier: 'comments',
  type: FieldType.TEXT_AREA,
  label: 'systemParameters.comments',
  placeholderSlug: 'systemParameters.commentsPlaceholder',
  validation: {
    required: false,
  },
};

export const SystemParameters = () => {
  const systemParameters = useSelector(getSystemParametersWithSelectedOption);
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Subtitle className={classes.subTitle}>{t('systemParametersScreen.subtitle')}</Subtitle>
      <div className={classes.scrollableContainer}>
        <div className={classes.componentContainer}>
          {systemParameters.map((component) => {
            if (component.active === false) {
              return null;
            }
            return (
              <Grid key={component.identifier} container className={classes.component}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <label>{component.title}</label>
                </Grid>
                <Grid item xs={6}>
                  <Grid container direction="column">
                    <Grid item xs={12}>
                      <ComponentFieldRenderer
                        componentInputTypes={componentInputTypes}
                        component={component}
                      />
                    </Grid>
                    <Grid item container xs={12}>
                      <OptionComment component={component} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
          <Grid key={'comments'} container className={classes.component}>
            <Grid item xs={6} className={classes.labelContainer}>
              <label>{t('systemParameters.comments')}</label>
            </Grid>
            <Grid item xs={6}>
              <FormFieldRenderer field={comments} />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default SystemParameters;
